//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { openModal } from "../../features/dashBoard/dashboardSlice";
import { CROSS_BASKET_BLOCK } from "../../models/_consts";
import { useHistory } from "react-router-dom";
import MainModal from "../_layout/MainModal";
//#endregion

export default function CrossBasketBlockModal() {
  //#region SETUP
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { basket } = useAppSelector((state) => state.basket);
  const instoreActive = useAppSelector(
    (state) => state.instoreBasket.items.length > 0
  );

  const promoActive = !!basket;

  const currentType = instoreActive
    ? "instore order"
    : promoActive
    ? "promo"
    : "";
  const otherType = instoreActive ? "promo" : "instore order";

  // The two baskets are mutually exclusive — link to whichever is active.
  const basketTo = instoreActive ? "/instore-basket" : "/basket";

  const close = () => dispatch(openModal(false));
  const goToBasket = () => {
    close();
    history.push(basketTo);
  };
  //#endregion

  //#region RENDER
  return (
    <MainModal type={CROSS_BASKET_BLOCK} closeHandler={close}>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            className="h-6 w-6 text-amber-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Cross-type orders not allowed
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              {`It is not possible to order a ${otherType} while you still have a ${currentType} in your basket. Please complete or clear your current basket first.`}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          onClick={goToBasket}
          className="inline-flex w-full justify-center rounded-md bg-pink-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 sm:ml-3 sm:w-auto"
        >
          Go to basket
        </button>
        <button
          type="button"
          onClick={close}
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
        >
          OK
        </button>
      </div>
    </MainModal>
  );
  //#endregion
}
